'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.WithExpandedMenus = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _lodash = require('lodash');

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var WithExpandedMenus = exports.WithExpandedMenus = function (_Component) {
  _inherits(WithExpandedMenus, _Component);

  function WithExpandedMenus() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, WithExpandedMenus);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = WithExpandedMenus.__proto__ || Object.getPrototypeOf(WithExpandedMenus)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      expandedMenus: _this.props.expandedMenus
    }, _this.handleExpandMenuClick = function (menuKey) {
      var prevExpandedMenus = _this.state.expandedMenus;
      // adds or removes the menuKey based on it's existence in the current expanded menus array.

      var expandedMenus = (0, _lodash.includes)(prevExpandedMenus, menuKey) ? (0, _lodash.without)(prevExpandedMenus, menuKey) : prevExpandedMenus.concat(menuKey);

      _this.setState({ expandedMenus: expandedMenus });

      // Alerts the app level component to the new expanded menus. Mainly used for
      // persistence to local storage and setting initial state.
      _this.props.onChangeExpandedMenus({ expandedMenus: expandedMenus });
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  /**
   * Includes logic for updating the expanded menus in state, and updating the
   * app level component via onChangeExpandedMenus.
   * @param {string} menuKey a key used to identify a specific menu.
   */


  _createClass(WithExpandedMenus, [{
    key: 'render',
    value: function render() {
      // "consume" the props that no longer need to be passed down for proper functionality
      var passThroughProps = (0, _lodash.omit)(this.props, ['onChangeExpandedMenus', 'render']);

      return this.props.render(_extends({}, passThroughProps, {
        expandedMenus: this.state.expandedMenus,
        handleExpandMenuClick: this.handleExpandMenuClick
      }));
    }
  }]);

  return WithExpandedMenus;
}(_react.Component);

/* istanbul ignore next */


WithExpandedMenus.propTypes = {
  expandedMenus: _propTypes2.default.arrayOf(_propTypes2.default.string),
  onChangeExpandedMenus: _propTypes2.default.func,
  render: _propTypes2.default.func.isRequired
};
WithExpandedMenus.defaultProps = {
  expandedMenus: [],
  onChangeExpandedMenus: _lodash.noop
};
var withExpandedMenus = function withExpandedMenus(WrappedComponent) {
  return function (props) {
    return _react2.default.createElement(WithExpandedMenus, _extends({}, props, {
      render: function render(componentProps) {
        return _react2.default.createElement(WrappedComponent, componentProps);
      }
    }));
  };
};

exports.default = withExpandedMenus;


//////////////////
// WEBPACK FOOTER
// ./node_modules/base-components/build/components/LeftNav/withExpandedMenus.js
// module id = 1679
// module chunks = 2